// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyADwNGyylPmHE6GSS84-cESqf6F1P5AOqU',
    authDomain: 'kesef-app.firebaseapp.com',
    projectId: 'kesef-app',
    storageBucket: 'kesef-app.appspot.com',
    messagingSenderId: '28568989037',
    appId: '1:28568989037:web:8b46ce5676ed67eebe3e64',
    measurementId: 'G-N9YDGW3Q5W',
  },
};





/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
